module.exports = __webpack_public_path__ + "static/condo_design-mobile-7f04c77698a6440ede50c05d6701cc34.png";